import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconCollapse = deprecatedComponent({
    displayName: 'IconCollapse',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M12.7535 6.1749V2.32886C12.7535 1.91465 12.4177 1.57886 12.0035 1.57886C11.5893 1.57886 11.2535 1.91465 11.2535 2.32886L11.2535 7.98572C11.2535 8.18463 11.3325 8.3754 11.4732 8.51605C11.6138 8.6567 11.8052 8.73572 12.0041 8.73572L17.6604 8.73572C18.0746 8.73572 18.4104 8.39993 18.4104 7.98572C18.4104 7.5715 18.0746 7.23572 17.6604 7.23572H13.814L19.1634 1.88629C19.4563 1.59339 19.4563 1.11852 19.1634 0.825627C18.8705 0.532734 18.3957 0.532734 18.1028 0.825627L12.7535 6.1749Z",
            fill: "black"
        }), /*#__PURE__*/ React.createElement("path", {
            d: "M7.24289 17.6655C7.24289 18.0797 7.57867 18.4155 7.99289 18.4155C8.4071 18.4155 8.74289 18.0797 8.74289 17.6655L8.74289 12.0087C8.74289 11.8097 8.66387 11.619 8.52322 11.4783C8.38256 11.3377 8.19116 11.2587 7.99225 11.2587L2.33603 11.2587C1.92182 11.2587 1.58603 11.5944 1.58603 12.0087C1.58603 12.4229 1.92182 12.7587 2.33603 12.7587H6.18238L0.832951 18.1081C0.540058 18.401 0.540058 18.8759 0.832951 19.1688C1.12584 19.4616 1.60072 19.4616 1.89361 19.1688L7.24289 13.8195L7.24289 17.6655Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconCollapse };
